import { gql } from '@apollo/client';

export const UPDATE_NEWSLETTER_SUBSCRIPTION = gql`
  mutation UPDATE_NEWSLETTER_SUBSCRIPTION($hasOptIn: Boolean!) {
    updateNewsletterSubscription(hasOptIn: $hasOptIn)
  }
`;
